var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"inline-flex items-center justify-center mt-4 px-8 py-2 font-semibold transition-colors rounded-md focus:outline-none",class:{ primary: _vm.primary, secondary: _vm.secondary }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }